import { useNavigate } from "react-router-dom";
import PageHeading from "../../Components/PageHeading/PageHeading";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import { useContext, useEffect, useState, useRef, useCallback } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import { randomFactOfTheDayTopics } from "./FactOfTheDayTopic";
import AiContentAudit from "../../Components/AiContentAudit/AiContentAudit";
import { IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import SampleImageModal from "../../Components/SampleImageModal/SampleImageModal";
import AiFactsDisplay from "../../Components/AiFacts/AiFactsDisplay";

const backgroundColorOptions = [
    { value: "deep-navy-blue", label: "Deep Navy Blue" },
    { value: "rich-indigo", label: "Rich Indigo" },
    { value: "dark-forest-green", label: "Dark Forest Green" },
    { value: "dark-maroon-burgundy", label: "Dark Maroon / Burgundy" },
    { value: "deep-teal", label: "Deep Teal" },
    { value: "dark-espresso-brown", label: "Dark Espresso Brown" },
    { value: "true-charcoal-black", label: "True Charcoal Black" },
    { value: "indigo-violet", label: "Indigo-Violet" },
    { value: "darker-imperial-purple", label: "Darker Imperial Purple" },
    { value: "deep-olive-drab", label: "Deep Olive Drab" },
    { value: "midnight-arctic-blue", label: "Midnight Arctic Blue" },
    { value: "very-dark-aubergine", label: "Very Dark Aubergine" },
    { value: "dark-hunter-green", label: "Dark Hunter Green" },
    { value: "dark-crimson", label: "Dark Crimson" },
];

const specificTextColors = [
    { value: "white", label: "White" },
    { value: "vibrant-gold", label: "Vibrant Gold" },
    { value: "gold", label: "Gold" },
    { value: "soft-mint", label: "Soft Mint" },
    { value: "bright-amber", label: "Bright Amber" },
    { value: "azure-mist", label: "Azure Mist" },
    { value: "creamed-honey", label: "Creamed Honey" },
    { value: "medium-gray", label: "Medium Gray" },
    { value: "lavender-mist", label: "Lavender Mist" },
    { value: "amber", label: "Amber" },
    { value: "wheat", label: "Wheat" },
    { value: "light-blue", label: "Light Blue" },
    { value: "goldenrod", label: "Goldenrod" },
    { value: "light-green", label: "Light Green" },
    { value: "lemon-chiffon", label: "Lemon Chiffon" },
];

const textColorOptions = [
    { value: "random", label: "Random" },
    ...specificTextColors,
];

const getRandomBackgroundColor = () => {
    const randomIndex = Math.floor(Math.random() * backgroundColorOptions.length);
    return backgroundColorOptions[randomIndex].value;
};

const getRandomTextColor = (excludeColor = null) => {
    const availableColors = specificTextColors.filter(option => option.value !== excludeColor);
    if (availableColors.length === 0) return specificTextColors[0].value;
    const randomIndex = Math.floor(Math.random() * availableColors.length);
    return availableColors[randomIndex].value;
};

const baseCredit = 75;

const FactOfTheDayAi = () => {
    const [topic, setTopic] = useState("Random");
    const [backgroundColor, setBackgroundColor] = useState(() => getRandomBackgroundColor());
    const [textColors, setTextColors] = useState(() => {
        const t1 = getRandomTextColor();
        const t2 = getRandomTextColor(t1);
        const t3 = getRandomTextColor(t2);
        return { textColor1: t1, textColor2: t2, textColor3: t3 };
    });

    const [auditChecked, setAuditChecked] = useState(false);
    const credit = auditChecked ? baseCredit + 84 : baseCredit;
    //cost of 75 credit is 0.90 usd
    //cost of 84 credit is 1.01 usd
    const creditCostUSD = auditChecked ? 0.90 + 1.01 : 0.90;
    const [showImageModal, setShowImageModal] = useState(false);
    const [customTopic, setCustomTopic] = useState("");
    const [resultData, setResultData] = useState(null);
    const [jobProgress, setJobProgress] = useState(0);
    const [jobStatusText, setJobStatusText] = useState("");
    const pollingRef = useRef(null);

    const [customBgColor, setCustomBgColor] = useState("#000000");
    const [customTextColor1, setCustomTextColor1] = useState("#ffffff");
    const [customTextColor2, setCustomTextColor2] = useState("#ffffff");
    const [customTextColor3, setCustomTextColor3] = useState("#ffffff");

    const textColor1 = textColors.textColor1;
    const textColor2 = textColors.textColor2;
    const textColor3 = textColors.textColor3;

    const handleTextColor1Change = (val) => {
        setTextColors((prev) => {
            const nextT2 = (val !== "random" && val !== "custom" && prev.textColor2 === val) ? "random" : prev.textColor2;
            const nextT3 = (val !== "random" && val !== "custom" && prev.textColor3 === val) ? "random" : prev.textColor3;
            return { textColor1: val, textColor2: nextT2, textColor3: nextT3 };
        });
    };

    const setTextColor2 = (val) => {
        setTextColors((prev) => {
            const nextT3 = (val !== "random" && val !== "custom" && prev.textColor3 === val) ? "random" : prev.textColor3;
            return { ...prev, textColor2: val, textColor3: nextT3 };
        });
    };

    const setTextColor3 = (val) => {
        setTextColors((prev) => ({ ...prev, textColor3: val }));
    };

    const [attributionPage, setAttributionPage] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
    const navigate = useNavigate();

    const creditToLocalString = AIuser?.credits
        ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
        : "0";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Cleanup polling on unmount
    useEffect(() => {
        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
        };
    }, []);

    const pollJobStatus = useCallback((jobId) => {
        pollingRef.current = setInterval(async () => {
            try {
                const res = await fetch(
                    `https://backend.whalesai.com/api/v1/jobs/${jobId}`,
                    {
                        headers: {
                            authorization: `Bearer ${localStorage.getItem("aiUser")}`,
                        },
                    }
                );
                const data = await res.json();

                if (!data.success) {
                    clearInterval(pollingRef.current);
                    pollingRef.current = null;
                    setIsLoading(false);
                    setJobProgress(0);
                    setJobStatusText("");
                    swal({
                        text: "Failed to check job status.",
                        icon: "error",
                        buttons: "Ok",
                        className: "modal_class_success",
                    });
                    return;
                }

                const job = data.job;
                setJobProgress(job.progress || 0);
                setJobStatusText(job.status || "");

                if (job.completed) {
                    clearInterval(pollingRef.current);
                    pollingRef.current = null;
                    setIsLoading(false);
                    setJobProgress(0);
                    setJobStatusText("");

                    // Set result from job.result
                    setResultData({
                        imageUrl: job.result?.resultUrl,
                        title: job.result?.title,
                        fact: job.result?.fact,
                        caption: job.result?.caption,
                    });

                    // Reset form
                    setTopic("Random");
                    setCustomTopic("");
                    const newBg = getRandomBackgroundColor();
                    const newT1 = getRandomTextColor();
                    const newT2 = getRandomTextColor(newT1);
                    const newT3 = getRandomTextColor(newT2);
                    setBackgroundColor(newBg);
                    setTextColors({ textColor1: newT1, textColor2: newT2, textColor3: newT3 });
                    setCustomBgColor("#000000");
                    setCustomTextColor1("#ffffff");
                    setCustomTextColor2("#ffffff");
                    setCustomTextColor3("#ffffff");

                    const wrapper = document.createElement("div");
                    wrapper.innerHTML = `<p class="text-white">Your Fact of the Day has been generated successfully<br/>You can view and download it below.</p>`;

                    swal({
                        content: wrapper,
                        icon: "success",
                        button: "Close",
                        className: "modal_class_success",
                    });
                }

                if (job.failed) {
                    clearInterval(pollingRef.current);
                    pollingRef.current = null;
                    setIsLoading(false);
                    setJobProgress(0);
                    setJobStatusText("");
                    swal({
                        text: job.error || "Generation failed. Please try again.",
                        icon: "error",
                        buttons: "Ok",
                        className: "modal_class_success",
                    });
                }
            } catch (err) {
                console.error("Polling error:", err);
            }
        }, 3000);
    }, []);

    // const handleSubmitCredits = async () => {
    //     const deductedCredits = AIuser.credits - credit;
    //     await axios
    //         .put(
    //             "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
    //             { email: AIuser?.email, credits: deductedCredits },
    //             {
    //                 headers: {
    //                     authorization: `Bearer ${localStorage.getItem("aiUser")}`,
    //                 },
    //             },
    //         )
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setUserRefetch(!userRefetch);
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };

    const handleGenerate = async () => {
        if (AIuser.credits < credit) {
            swal({
                text: "You don't have enough credits! Please buy credits to continue.",
                icon: "error",
                buttons: "Buy",
                className: "modal_class_success",
            }).then((value) => {
                if (value) {
                    navigate("/purchase");
                }
            });
            return;
        }

        setIsLoading(true);
        setJobProgress(0);
        setJobStatusText("");
        setResultData(null);

        try {
            const finalTopic = topic === "Other" ? customTopic : topic;

            if (topic === "Other" && !customTopic.trim()) {
                swal({
                    text: "Please enter a custom topic.",
                    icon: "error",
                    buttons: "Ok",
                    className: "modal_class_success",
                });
                setIsLoading(false);
                return;
            }

            const body = {
                credit,
                topic: finalTopic,
                bgColor: backgroundColor === "custom" ? customBgColor : backgroundColor,
                textColor1: textColor1 === "custom" ? customTextColor1 : textColor1,
                textColor2: textColor2 === "custom" ? customTextColor2 : textColor2,
                textColor3: textColor3 === "custom" ? customTextColor3 : textColor3,
                attributionPage,
                audit: auditChecked
            };

            const response = await fetch(
                "https://backend.whalesai.com/api/v1/fact-of-the-day-ai/generate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("aiUser")}`,
                    },
                    body: JSON.stringify(body),
                },
            );

            if (!response.ok) {
                throw new Error("Failed to generate Fact Of The Day");
            }

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.message || "Generation failed");
            }

            // Deduct credits immediately after successful job submission
            // handleSubmitCredits();
            setUserRefetch(!userRefetch)

            // Start polling for job status
            const jobId = data.jobId;
            setJobStatusText(data.message || "Processing...");
            pollJobStatus(jobId);

        } catch (error) {
            console.error("Error generating Fact Of The Day:", error);
            swal({
                text: error.message || "Something went wrong!",
                icon: "error",
                buttons: "Ok",
                className: "modal_class_success",
            });
            setIsLoading(false);
        }
    };

    const handleDownload = async ({ imageUrl }) => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const fileName = imageUrl.split("/").pop();
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Image download failed:", error);
        }
    };

    const handleClear = () => {
        setTopic("Random");
        setCustomTopic("");
        const newBg = getRandomBackgroundColor();
        const newT1 = getRandomTextColor();
        const newT2 = getRandomTextColor(newT1);
        const newT3 = getRandomTextColor(newT2);
        setBackgroundColor(newBg);
        setTextColors({ textColor1: newT1, textColor2: newT2, textColor3: newT3 });
        setCustomBgColor("#000000");
        setCustomTextColor1("#ffffff");
        setCustomTextColor2("#ffffff");
        setCustomTextColor3("#ffffff");
        setAttributionPage(true);
        setResultData(null);
    };

    const selectStyle = {
        background: "#011C34",
        border: "2px solid #FFF",
        borderRadius: "12px",
        outline: "none",
        cursor: "pointer",
        appearance: "auto",
    };

    return (
        <div>
            {/* <PageHeading
                title={"FACT OF THE DAY AI"}
                description={
                    "Turn daily facts into engaging images!"
                }
                onInfoClick={() => setShowImageModal(true)}
                infoTooltip="See sample fact of the day"
            /> */}

            <SampleImageModal
                imageModal={showImageModal}
                setImageModal={setShowImageModal}
                imageSrc="/fact-sample.png"
                title="What you can do?"
            />

            <div className="container pb-5">
                <div
                    style={{
                        maxWidth: "872px",
                        paddingInline: "12px",
                        marginInline: "auto",
                    }}
                >
                    <div className="container">
                        {/* Credits section */}
                        <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2">
                            <div>
                                {/* <div>
                                    <button className="credits-button">
                                        CREDITS : {creditToLocalString}
                                    </button>
                                    <button
                                        className="buy-credits-button"
                                        onClick={() => navigate("/purchase")}
                                    >
                                        BUY CREDITS
                                    </button>
                                    <button
                                        onClick={() => navigate("/usage")}
                                        className="money-exchange-button"
                                    >
                                        <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
                                    </button>
                                </div> */}
                                <p className="all-page-title all-page-gradient-text text-center my-4">FACT OF THE DAY AI</p>
                                <div className="credits-actions">

                                    <button className="credits-button">
                                        CREDITS : {creditToLocalString}
                                    </button>

                                    <button
                                        className="buy-credits-button"
                                        onClick={() => navigate("/purchase")}
                                    >
                                        BUY CREDITS
                                    </button>

                                    <button
                                        onClick={() => navigate("/usage")}
                                        className="money-exchange-button"
                                    >
                                        <img src={moneyExchangeIcon} alt="usage" />
                                    </button>

                                    <button
                                        type="button"
                                        className="money-exchange-button"
                                        onClick={() => {
                                            setShowImageModal(true);
                                        }}

                                    >
                                        <img src={sampleIcon} alt="See sample video" />
                                    </button>

                                </div>
                                <p
                                    style={{ fontSize: "8px" }}
                                    className="text-white mt-2 creditText text-center"
                                >
                                    {credit} Credits (USD {creditCostUSD.toFixed(2)} based on Credits Package 3)
                                </p>
                            </div>
                        </div>

                        {/* Topic dropdown */}
                        <div className="mb-3 mt-3">
                            <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                                Topic
                            </label>
                            <select
                                className="p-2 px-3 w-100 text-white"
                                style={selectStyle}
                                value={topic}
                                onChange={(e) => setTopic(e.target.value)}
                            >
                                <option value="Random">Random</option>
                                <option value="Other" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Other (Custom Topic)</option>
                                {randomFactOfTheDayTopics?.sort((a, b) => a.localeCompare(b)).map((t) => (
                                    <option key={t} value={t}>
                                        {t}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {topic === "Other" && (
                            <div className="mb-3">
                                <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                                    Enter Custom Topic <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="p-2 px-3 w-100 text-white"
                                    style={selectStyle}
                                    placeholder="e.g., Quantum Physics"
                                    value={customTopic}
                                    onChange={(e) => setCustomTopic(e.target.value)}
                                />
                            </div>
                        )}

                        {/* Color dropdowns */}
                        <div className="d-flex flex-column flex-md-row gap-3 mb-3">
                            <div className="flex-fill">
                                <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                                    Background
                                </label>
                                <select
                                    className="p-2 px-3 w-100 text-white"
                                    style={selectStyle}
                                    value={backgroundColor}
                                    onChange={(e) => setBackgroundColor(e.target.value)}
                                >
                                    <option value="custom" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Custom Color</option>
                                    <option value="random">Random</option>
                                    {backgroundColorOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {backgroundColor === "custom" && (
                                    <div className="mt-2 text-center">
                                        <input
                                            type="color"
                                            value={customBgColor}
                                            onChange={(e) => setCustomBgColor(e.target.value)}
                                            style={{ width: "100%", height: "40px", cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                                        />
                                        <div className="text-white mt-1" style={{ fontSize: "12px", fontFamily: "monospace" }}>
                                            {customBgColor.toUpperCase()}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex-fill">
                                <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                                    Text Combination 01
                                </label>
                                <select
                                    className="p-2 px-3 w-100 text-white"
                                    style={selectStyle}
                                    value={textColor1}
                                    onChange={(e) => handleTextColor1Change(e.target.value)}
                                >
                                    <option value="custom" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Custom Color</option>
                                    {textColorOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {textColor1 === "custom" && (
                                    <div className="mt-2 text-center">
                                        <input
                                            type="color"
                                            value={customTextColor1}
                                            onChange={(e) => setCustomTextColor1(e.target.value)}
                                            style={{ width: "100%", height: "40px", cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                                        />
                                        <div className="text-white mt-1" style={{ fontSize: "12px", fontFamily: "monospace" }}>
                                            {customTextColor1.toUpperCase()}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex-fill">
                                <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                                    Text Combination 02
                                </label>
                                <select
                                    className="p-2 px-3 w-100 text-white"
                                    style={selectStyle}
                                    value={textColor2}
                                    onChange={(e) => setTextColor2(e.target.value)}
                                >
                                    <option value="custom" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Custom Color</option>
                                    {textColorOptions
                                        .filter((option) => option.value === "random" || option.value !== textColor1)
                                        .map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                </select>
                                {textColor2 === "custom" && (
                                    <div className="mt-2 text-center">
                                        <input
                                            type="color"
                                            value={customTextColor2}
                                            onChange={(e) => setCustomTextColor2(e.target.value)}
                                            style={{ width: "100%", height: "40px", cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                                        />
                                        <div className="text-white mt-1" style={{ fontSize: "12px", fontFamily: "monospace" }}>
                                            {customTextColor2.toUpperCase()}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex-fill">
                                <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                                    Text Combination 03
                                </label>
                                <select
                                    className="p-2 px-3 w-100 text-white"
                                    style={selectStyle}
                                    value={textColor3}
                                    onChange={(e) => setTextColor3(e.target.value)}
                                >
                                    <option value="custom" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Custom Color</option>
                                    {textColorOptions
                                        .filter((option) => option.value === "random" || (option.value !== textColor1 && option.value !== textColor2))
                                        .map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                </select>
                                {textColor3 === "custom" && (
                                    <div className="mt-2 text-center">
                                        <input
                                            type="color"
                                            value={customTextColor3}
                                            onChange={(e) => setCustomTextColor3(e.target.value)}
                                            style={{ width: "100%", height: "40px", cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                                        />
                                        <div className="text-white mt-1" style={{ fontSize: "12px", fontFamily: "monospace" }}>
                                            {customTextColor3.toUpperCase()}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Attribution checkbox */}
                        <div
                            className="d-flex align-items-center justify-content-center text-center mt-4 mb-2"
                        >
                            <input
                                type="checkbox"
                                id="attributionCheckboxInline"
                                style={{ marginRight: '8px' }}
                                checked={attributionPage}
                                onChange={(e) => setAttributionPage(e.target.checked)}
                            />
                            <label htmlFor="attributionCheckboxInline" className="text-white" style={{ fontSize: '14px', cursor: 'pointer' }}>
                                The Attribution
                            </label>
                        </div>

                        <AiContentAudit checked={auditChecked} onChange={setAuditChecked} auditCreditCost={84} />

                        {/* Action Buttons */}
                        <div className="d-flex justify-content-center align-items-center mb-5">
                            <Button
                                sx={{
                                    padding: "8px 30px",
                                    marginRight: "10px",
                                    color: "#000",
                                    background: "#fff",
                                    "&:hover": { background: "#fff" },
                                    "&:disabled": { background: "#fff" },
                                }}
                                onClick={handleClear}
                                disabled={isLoading}
                                variant="contained"
                            >
                                Clear
                            </Button>
                            <Button
                                sx={{
                                    padding: "8px 30px",
                                    "&:disabled": { background: "#000" },
                                }}
                                onClick={handleGenerate}
                                className="generate-button text-white"
                                disabled={isLoading}
                                variant="contained"
                            >
                                {isLoading ? "Processing..." : "Generate"}
                            </Button>
                        </div>

                        <div className="animate text-md-center text-lg-center text-center mb-5 d-flex justify-content-center force-small-font">
                            Please do not navigate away from the browser.
                            <br /> Doing so will stop the process.
                        </div>
                        <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
                            While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
                        </div>

                        {/* Progress section */}
                        {isLoading && (
                            <div className="d-flex flex-column align-items-center mt-4 mb-3">
                                <div
                                    className="spinner-border text-light mb-3"
                                    role="status"
                                    style={{ width: "3rem", height: "3rem" }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                {jobStatusText && (
                                    <p className="text-warning text-center mb-2" style={{ fontSize: "14px" }}>
                                        {jobStatusText}
                                    </p>
                                )}
                                <div style={{
                                    width: "100%",
                                    maxWidth: "400px",
                                    background: "#0b2d4d",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    height: "20px",
                                    border: "1px solid #1a4a7a",
                                }}>
                                    <div style={{
                                        width: `${jobProgress}%`,
                                        height: "100%",
                                        background: "linear-gradient(90deg, #ffa21f, #ff6b00)",
                                        borderRadius: "10px",
                                        transition: "width 0.5s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }} />
                                </div>
                                <p className="text-white mt-1" style={{ fontSize: "12px" }}>
                                    {jobProgress}%
                                </p>
                            </div>
                        )}
                        {/* Interesting facts while generating */}
                        {isLoading && <AiFactsDisplay />}
                        {resultData && !isLoading && (
                            <div className="mt-5 d-flex flex-column align-items-center justify-content-center">
                                {resultData.title && (
                                    <p className="text-white fs-4 fw-bold text-center">{resultData.title}</p>
                                )}
                                {resultData.fact && (
                                    <p className="text-warning fs-5 text-center">{resultData.fact}</p>
                                )}
                                {resultData.caption && (
                                    <p className="text-light text-center fst-italic mb-4">{resultData.caption}</p>
                                )}
                                {resultData.imageUrl && (
                                    <>
                                        <p className="text-white mt-4">Generated Image</p>
                                        <img src={resultData.imageUrl} alt="Generated Fact" className="img-fluid" />
                                        <button
                                            className="btn btn-success mt-3"
                                            onClick={() => {
                                                handleDownload({ imageUrl: resultData.imageUrl })
                                            }}
                                        >
                                            <i className="fa-solid fa-download"></i>
                                            {' '}
                                            Download
                                        </button>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FactOfTheDayAi;